import { lazy } from "react";

const RatingManagementPage = lazy(() => import("./main"));
const MDetailPage = lazy(() => import("./detail"));

export { RatingManagementPage, MDetailPage };
